/*
  Este módulo esta pensando para operar con rutas dinámicas
  se requiere setear en las variables de entorno
  - VUE_APP_DYNAMIC_ROUTER=yes
  - VUE_APP_PROYECT_VIEWS_FOLDER=@/views/[carpeta-del-proyecto] (opcional)

  https://github.com/lumile/lumbre/discussions/896
*/

import Vue from 'vue'
import Router from 'vue-router'
import { generateRoutes } from '@/helpers/LmDynamicRoutes'

import LumbreApp from './views/LumbreApp'
import store from './store'

// Por alguna razon necesito esta importación para que funcionen los iconos de font-awesome (ver)
// eslint-disable-next-line
import /* webpackChunkName: "LmList" */ LmList from '@/components/LmList'

Vue.use(Router)

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export async function createRouter () {
  const routerConfig = {
    mode: 'history',
    routes: [
      {
        path: '/',
        component: LumbreApp,
        meta: {
          title: 'LumbreDocs',
          breadcrumb: new MetaBreadcrumb('Dashboard', '/')
        },
        children: [
          {
            path: '',
            name: 'dashboard_home',
            meta: {
              title: 'Dashboard'
            },
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DashboardHome.vue')
          },
          {
            path: 'inbox',
            name: 'inbox',
            meta: {
              title: 'Bandeja de Entrada'
            },
            component: () => import(/* webpackChunkName: "inbox" */ '@/views/LmInbox.vue')
          }
        ]
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          title: 'Login'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
      },
      {
        path: '/document-sign/:token/:id',
        name: 'Firmador de documento',
        meta: {
          title: 'Firmador de documento'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/DocumentSign.vue')
      },
      {
        // path: '/document-sign/:token/:id',
        // Usar una ruta más descriptiva y amigable
        path: '/document-sign/document-id/:id/token/:token',
        name: 'Firmador de documento',
        meta: {
          title: 'Firmador de documento'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/DocumentSign.vue')
      },
      {
        path: '/callback',
        name: 'callback',
        component: () => import(/* webpackChunkName: "callback" */ '@/views/Callback.vue')
      },
      {
        path: '/no-permitido',
        name: '401',
        component: () => import(/* webpackChunkName: "404" */ '@/views/401.vue')
      },
      {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
      },
      {
        path: '/bibliotecapublica/:slug',
        name: 'Biblioteca de documentos',
        meta: {
          title: 'Biblioteca de documentos'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/LmPublicLibrary.vue')
      },
      {
        path: '/bibliotecapublica/:slug/page/:id',
        name: 'Page Biblioteca de documentos',
        meta: {
          title: 'Page Biblioteca de documentos'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/LmPublicLibraryPage.vue')
      }
    ]
  }

  // Si se requiere "restablecer contraseña"
  if (process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD === 'yes') {
    routerConfig.routes.push({
      path: '/restore-password',
      name: 'restore-password',
      component: () => import(/* webpackChunkName: "restore-password" */ '@/views/restorePassword.vue')
    })
  }

  try {
    if (store.getters['session/isAuthenticated']) {
      const routes = await generateRoutes()
      routerConfig.routes = routerConfig.routes.concat(routes)
    }
  } catch (error) {
    console.log(error)
  }

  return new Router(routerConfig)
}
